import './App.css';
import Header from './components/Header';
import './styles/style.scss';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Index from './Pages/Index';
import Footer from './components/Footer';
import NavigationBar from './components/NavigationBar';
import SnapStudio from './Pages/SnapStudio';


function App() {

     function PublicLayout() {
          return (
               <>
                    <Header />
                    <Outlet />
                    <Footer/>
                    <NavigationBar/>
               </>
          );
     }

     return (
          <>
               <Router>
                    <Routes>
                         <Route element={<PublicLayout />}>
                              <Route path='/' element={<Index />} />
                         </Route>
                         <Route path='/tools/snapstudio' element={<SnapStudio />} />
                    </Routes>
               </Router>


          </>
     );
}

export default App;
